import { toast } from "react-toastify";

export const purgeUpdateAndRedirect = (purge, redirect) => {
  purge();
  redirect();
  toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
    position: toast.POSITION.BOTTOM_RIGHT,
  });
  return;
};
